import { useSelector } from 'react-redux';

type FeatureFlagsState = {
  featureFlags: { flags?: Record<string, boolean> };
};

export function useSupportHubEnabled(): boolean {
  return Boolean(
    useSelector(
      (state: FeatureFlagsState) =>
        state.featureFlags.flags?.SUPPORT_HUB_ENABLED
    )
  );
}
